/**
 * MindOS integration settings.
 *
 * The MindOS web app itself lives, unmodified, in `public/modules/mindos/`
 * and is served as static files at `/modules/mindos/`. This feature folder is
 * only the thin connector that hosts it inside the dashboard, so:
 *
 *  - Updating MindOS  → `npm run mindos:update -- path/to/WebApp.zip`
 *                       (or replace the contents of public/modules/mindos/).
 *  - Moving MindOS    → change `baseUrl` (e.g. to another host that serves it
 *                       over HTTPS) — nothing else in the dashboard changes.
 *  - Removing MindOS  → delete this folder, its route in app/routes.tsx and
 *                       its entry in app/modules.ts.
 */
export const mindosConfig = {
  /** Where the MindOS static bundle is served from. Must be HTTPS (or localhost) for Web Bluetooth. */
  baseUrl: import.meta.env.VITE_MINDOS_URL ?? '/modules/mindos/',
  /** Entry page inside the bundle. */
  entry: 'index.html',
  /** localStorage key remembering that the user has read the Bluetooth notice. */
  noticeKey: 'ela.mindos.bluetoothNoticeAccepted',
} as const;

export function mindosEntryUrl(): string {
  const base = mindosConfig.baseUrl.endsWith('/') ? mindosConfig.baseUrl : `${mindosConfig.baseUrl}/`;
  return `${base}${mindosConfig.entry}`;
}
